import React, { Component } from 'react'
import {Pie} from 'react-chartjs-2';
import posts_per_tag from '../json/posts_per_tag_30.json'

var array_keys = new Array();
var array_values = new Array();

let index = 0
let count = 0
for (var key in posts_per_tag) {
    if(index<20) {
        array_keys.push(key);
        array_values.push(posts_per_tag[key]);
    }else{
        count = count + posts_per_tag[key];
    }
    index++;
}
array_keys.push('Others');
array_values.push(count);

let colors = []
for(var i=0; i<20; i++) {
  colors.push('#'+Math.floor(Math.random()*16777215).toString(16));
}

const data = {
	labels: array_keys,
	datasets: [{
        data: array_values,
        backgroundColor: colors
    }],
};

export class TagUsageChart extends Component {
  render() {
    return (
      <div>
        <h2>标签使用</h2>
        <Pie data={data} />
      </div>
    );
  }
}

export default TagUsageChart  
